
export enum MdEnableStatusEnum {
    DISABLE,
    ENABLE
}

export enum DisableFlagEnum {
    normal,
    disabled,
}
// 编辑操作模式
export enum EditModeEnum {
    edit,
    look,
    add
}
export enum MaterialTypeEnum {
    Engine = '发动机',
    Gearbox = '变速箱',
    Axle = '车桥',
    Vehicle = '整车'
}

// 通知公告接收类型
export enum ReceiverEnum {
    'ALL' = "全部",
    'ORG' = "部门",
    'USER' = "指定用户"
}
export enum DetailType {
    "add" = "add",
    "edit" = "edit",
    "look" = "look"
}
export interface ISearchPage {
    pageSize?: number,
    pageNum?: number,
    current?: number,
}
export interface IPgProps {
    total: number,
    size: number,
    pageNum: number,
    current: number
}
export interface IPage<T> extends IPgProps {
    records: T[],
}

export interface IPageRet<T> {
    retCode: string,
    retMsg: string,
    retData: IPage<T>
}